const getRegionBreakdown = (
  countryIds: string[] | string | undefined,
  region: string[] | string | undefined,
  compareMode?: string | boolean | undefined,
  customRegions?: any
): string => {
  if (
    (Array.isArray(countryIds) ||
      Array.isArray(region) ||
      Array.isArray(customRegions)) &&
    (!compareMode || compareMode === 'entity')
  ) {
    return 'none';
  }
  const countryExistsAndNotEx =
    (Array.isArray(countryIds) && !countryIds[0].includes('EX')) ||
    (countryIds && !countryIds.includes('EX'));
  return (region && countryExistsAndNotEx) || customRegions
    ? 'none'
    : region
    ? 'region'
    : countryExistsAndNotEx
    ? 'country'
    : 'none';
};

export default getRegionBreakdown;
